/*

*/

import React, {Component} from 'react';
import RegistrationSetting from './RegistrationSetting'
import OtherSettings from './OtherSettings'

import './TicketList.scss'

class TicketList extends Component{

  constructor(props){
    super(props)

    this.state = {
    }
  }

  renderRegistrationSetting(){
    const {ticketList, onTicketChange, removeTicket} = this.props
    return ticketList.map((ticket, index) => {
      return(
        <RegistrationSetting
          key={index}
          ticket={ticket}
          onTicketChange={onTicketChange(index, ticket.id)}
          onRemoveTicket={removeTicket(index, ticket)}
          type={ticket.price_type}
        />
      )
    })
  }

  render(){
    let {showingBasic} = this.state;
    const {ticketList = [], onTicketChange, addTicket} = this.props

    return(
      <div className='ticket-content'>
        <p className='ticket-title'>
          {__('Registration Setup', 'ticket')}
          <span className='red'>*</span>
        </p>
        <div className='container-fluid ticket-container'>
          { ticketList.length > 0 &&
          <div className='row btn-row'>
            <div className='col-xs-4'>
              {__('Registration Title', 'ticket')}
              <span className='red'>*</span>
            </div>
            <div className='col-xs-3'>
              {__('Amount of People', 'ticket')}
              <span>{__(' (No limit if empty)', 'ticket')}</span>
            </div>
            <div className='col-xs-3'>{__('Price Description', 'ticket')}</div>
            <div className='col-xs-2'>{__('Settings', 'ticket')}</div>
          </div>
          }
          {this.renderRegistrationSetting()}
          <div className='row btn-row'>
            <div className='col-xs-5 register-btn text-center' onClick={() => {
              addTicket('freeOrPayOffline');
            }}>
              <i className='fa icon-plus plus-1'></i>
              <span className='registration-reg'>{__('Registration', 'ticket')}</span>
            </div>

            <div className='col-xs-5 register-btn text-center' onClick={() => {
              addTicket('fixedAmount');
            }}>
              <i className='fa icon-plus plus-2'></i>
              <span className='registration-with-fee'>{__('Registration with Fees', 'ticket')}</span>
            </div>

          </div>

        </div>
        <OtherSettings />
      </div>
    )
  }
}


export default TicketList



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster-archieve/TicketList.js